import { BaseApiClient } from '../client'
import type {
  CreatorProgram,
  CreateCreatorProgramInput,
  UpdateCreatorProgramInput,
} from '@/lib/types'

export class CreatorProgramsApi extends BaseApiClient {
  async list(): Promise<CreatorProgram[]> {
    return this.request<CreatorProgram[]>('/api/admin/creator-programs')
  }

  async get(id: string): Promise<CreatorProgram> {
    return this.request<CreatorProgram>(`/api/admin/creator-programs/${id}`)
  }

  async create(data: CreateCreatorProgramInput): Promise<CreatorProgram> {
    return this.request<CreatorProgram>('/api/admin/creator-programs', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  async update(id: string, data: UpdateCreatorProgramInput): Promise<CreatorProgram> {
    return this.request<CreatorProgram>(`/api/admin/creator-programs/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    })
  }

  async forceSync(id: string): Promise<{ success: boolean; message: string }> {
    return this.request<{ success: boolean; message: string }>(
      `/api/admin/creator-programs/${id}/sync`,
      { method: 'POST' }
    )
  }
}
